import SearchInput from "../../../../../components/inputs/searchInput";
import { useFormik } from "formik";
import SearchSelect from "../../../../../components/select/searchSelect";
import { SlCloudDownload } from "react-icons/sl";
import { useOptions } from "../../../../../components/hooks/useOptionsHook";
import Button from "../../../../../components/buttons/button";
import DateSearchInput from "../../../../../components/inputs/dateSearchInput";

const EntitlementSearch = ({ t }) => {
  const formik = useFormik({ initialValues: {} });
  const { employeesStatusOptions } = useOptions();

  return (
    <section className="flex flex-wrap items-center justify-between gap-3 mt-8 md:flex-nowrap">
      <div className="flex flex-wrap items-center w-full gap-3 md:w-1/3 md:flex-nowrap">
        <SearchInput
          formik={formik}
          name={"search"}
          placeholder={t("searchWithNameOrDepartment")}
        />
      </div>
      <div className="flex flex-wrap items-center w-full gap-2 md:w-auto md:flex-nowrap">
        <div className="w-full md:w-[170px]">
          <DateSearchInput formik={formik} name={"date"} placeholder={t("date")} />
        </div>
        <div className="w-full md:w-auto">
          <SearchSelect
            options={employeesStatusOptions}
            formik={formik}
            name={"department"}
            placeholder={t("department")}
          />
        </div>
        <div className="w-full md:w-auto">
          <Button
            type={"button"}
            className={"flex h-8 items-center rounded-lg gap-2 bg-[#1E4071]"}
          >
            <SlCloudDownload size={20} className="text-white" />
            {t("exportPDF")}
          </Button>
        </div>
      </div>
    </section>
  );
};

export default EntitlementSearch;
